import React, { useRef } from 'react';
import { Link } from 'react-router-dom';
import { FaArrowRight, FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import VegiPurrGrowth from '../assets/img/category pet/Adins vegipurr Growth ++.png';
import AllergySupport from '../assets/img/category pet/Allergy support.jpeg';
import ClamingChews from '../assets/img/category pet/calming Chews 2.png';
import Catnip from '../assets/img/category pet/catnip (3).jpg';
import DentalSticks from '../assets/img/category pet/Dental sticks.jpg';
import FrontMockup from '../assets/img/category pet/Front Mockup.png';
import HimalayanYakChews from '../assets/img/category pet/Himalayan Yak Chews.png';
import MilkBone from '../assets/img/category pet/milk bone.png';

interface Product {
  id: number;
  image: string;
  title: string;
  categoryLink: string;
}

const products: Product[] = [
  { id: 1, image: VegiPurrGrowth , title: 'VegiPurr Growth+', categoryLink: '/products' },
  { id: 2, image: AllergySupport , title: 'Allergy Support', categoryLink: '/products' },
  { id: 3, image: ClamingChews  , title: 'Calming Chews', categoryLink: '/products' },
  { id: 4, image: Catnip , title: 'Catnip', categoryLink: '/products' },
  { id: 5, image: DentalSticks , title: 'Dental Sticks', categoryLink: '/products' },
  { id: 6, image: FrontMockup , title: 'Probiotic Powder', categoryLink: '/products' },
  { id: 7, image: HimalayanYakChews, title: 'Himalayan Yak Chews', categoryLink: '/products' },
  { id: 8, image: MilkBone, title: 'Calcium Milk Bone', categoryLink: '/products' },
];

// title: 'Jute Grocery Bags'
// title: 'Cotton Canvas Bags'
// title: 'Cotton Tote Bags'

const FeaturedTrendyProducts: React.FC = () => {
  const scrollRef = useRef<HTMLDivElement>(null);

  const scrollLeft = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: -300, behavior: 'smooth' });
    }
  };

  const scrollRight = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: 300, behavior: 'smooth' });
    }
  };

  return (
    <div className="max-w-7xl mx-auto p-6 bg-gray-50 relative">
      <h2 className="text-5xl font-extrabold mb-14 mt-16 text-center text-gray-800">Featured Trendy <span className='text-[#f98715]'>Products </span></h2>
      <div className="relative">
        <button 
          onClick={scrollLeft} 
          className="hidden md:flex absolute left-[-56px] top-1/2 transform -translate-y-1/2 bg-[#f98715] text-white p-4 rounded-full shadow-xl hover:bg-[#e97313] transition"
        >
          <FaChevronLeft size={20} />
        </button>
        <div
          ref={scrollRef}
          className="flex overflow-x-auto gap-6 py-4 scroll-smooth md:scroll-auto no-scrollbar"
        >
          {products.map((product) => (
            <div
              key={product.id}
              className="flex-shrink-0 w-64 md:w-96 border-2 border-transparent rounded-lg p-4 bg-white shadow-lg hover:shadow-xl transition duration-500 transform hover:scale-105 hover:border-[#f98715] hover:cursor-pointer"
            >
              <img
                src={product.image}
                alt={product.title}
                className="w-full h-64 md:h-96 object-cover rounded-md transition-transform duration-300 transform hover:scale-105"
              />
              <Link to={product.categoryLink} className="mt-4 block text-lg md:text-xl font-semibold text-center text-gray-900 hover:text-[#f98715] transition-colors">
                {product.title}
                <FaArrowRight className="inline ml-2" />
              </Link>
            </div>
          ))}
        </div>
        <button 
          onClick={scrollRight} 
          className="hidden md:flex absolute right-[-50px] top-1/2 transform -translate-y-1/2 bg-[#f98715] text-white p-4 rounded-full shadow-xl hover:bg-[#e97313] transition"
        >
          <FaChevronRight size={20} />
        </button>
        <div className="flex justify-center gap-4 mt-6 md:hidden">
          <button 
            onClick={scrollLeft} 
            className="bg-[#f98715] text-white p-3 rounded-full shadow-md hover:bg-[#e97313] transition"
          >
            <FaChevronLeft size={20} />
          </button>
          <button 
            onClick={scrollRight} 
            className="bg-[#f98715] text-white p-3 rounded-full shadow-md hover:bg-[#e97313] transition"
          >
            <FaChevronRight size={20} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default FeaturedTrendyProducts;
